import { InactivityType, LocationType } from "__generated__/enums";

export const getLocationTypeForInactivity = (inactivityType: InactivityType): LocationType => {
	switch (inactivityType) {
		case InactivityType.Idle: return LocationType.WaitingArea;
		case InactivityType.Wharf: return LocationType.Wharf;
		case InactivityType.TradingDecision: return LocationType.Terminal;
	}
};
